module.exports = __webpack_public_path__ + "img/symbol_10_x6.f098c55e.png";